const normalizeBearing = (bearing: number): number => ((bearing % 360) + 360) % 360;

type BearingController = {
  getBearing: () => number;
  setBearing: (bearing: number) => unknown;
};

export const areBearingsEquivalent = (
  currentBearing: number,
  targetBearing: number,
  toleranceDegrees: number,
): boolean => {
  if (
    !Number.isFinite(currentBearing) ||
    !Number.isFinite(targetBearing) ||
    !Number.isFinite(toleranceDegrees) ||
    toleranceDegrees < 0
  ) {
    return false;
  }

  const normalizedCurrent = normalizeBearing(currentBearing);
  const normalizedTarget = normalizeBearing(targetBearing);
  const shortestDelta = ((normalizedCurrent - normalizedTarget + 540) % 360) - 180;
  return Math.abs(shortestDelta) <= toleranceDegrees;
};

export const setBearingIfMeaningfullyChanged = (
  map: BearingController,
  targetBearing: number,
  toleranceDegrees: number,
): boolean => {
  if (
    areBearingsEquivalent(map.getBearing(), targetBearing, toleranceDegrees) ||
    !Number.isFinite(targetBearing)
  ) {
    return false;
  }

  map.setBearing(targetBearing);
  return true;
};
